function getRefreshToken(): string | undefined {
  const csrfCookie = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('refresh='));

  return csrfCookie ? csrfCookie.split('=')[1] : undefined;
}

const refreshToken = async () => {
  const refresh = getRefreshToken();  // your helper

  const response = await fetch('/token/refresh/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refresh }),
    credentials: 'include',
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('Refresh failed:', response.status, errorText);
    throw new Error(`Token refresh failed (${response.status})`);
  }

  const { access: newAccessToken } = await response.json();

  document.cookie = `access=${newAccessToken};`;

  return newAccessToken;
};


export default refreshToken;
